  var initHelpLink = function(type, data) {
    if (type === 'video') {
      jQuery('.site-help-video').off('click');
      jQuery('.site-help-video').on('click', function() {
        var dialogContent = '<h1>NIRAS CVPT</h1><div class="embed-'+data+'"></div><script type="text/javascript" src="https://video.adalia.fi/embed/s/'+data+'?width=responsive"><\\/script>';
        Dialog.load({size: 'xl'}, function(setContent) {setTimeout(function(){setContent(dialogContent)}, 500);});
        jQuery('.site-help-video').tooltip('hide');
        return false;
      });
      jQuery('.site-help-video').show();
      jQuery('.site-help-video').tooltip();
    }
    else if (type === 'academy-link') {
      jQuery('.site-help-academy').off('click');
      jQuery('.site-help-academy').attr('href', '/smartme_academy/open/?target=' + encodeURIComponent(data)).attr('target', '_blank');
      jQuery('.site-help-academy').show();
    }

  }

  var initSiteHelpData = function() {
    var setLink = function(embedData) {
      var pageId = jQuery('body').attr('data-help-context');

      if (!pageId) {
        return;
      }

      jQuery.each(embedData, function(k,v) {
        var r = new RegExp(k.replace(/\./g,'\\\.').replace(/\*/g, '.*'));
        if (pageId.match(r)) {
          initHelpLink(v.type, v.data);
        }
      });
    }

    var pageData = JSON.parse(sessionStorage.getItem('siteHelpData'));
    if (sessionStorage.getItem('siteHelpData') !== null && (new Date().getTime()) - (new Date(Date.parse(pageData.time + 'z')).getTime()) < 3600*1000) {
      setLink(pageData.pages);
    }
    else if(!document.body.getAttribute('data-disable-help')) {
      // if (typeof User != 'undefined' && User.hasPermission('setting.site_help_json')) {
        $.getJSON('/setting/site_help_data').done(function(helpData){
          setLink(helpData.pages);
          sessionStorage.setItem('siteHelpData', JSON.stringify(helpData));
        });
      // }
    }
  }
  
window.initSiteHelpData = initSiteHelpData;